module.exports = __webpack_public_path__ + "img/win-wecom.059afe17.png";